import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  office: { name: '', referenceNumber: [], description: '' },
  seenStampData: [],
  isFetching: false,
  isSuccess: false,
  isResponseState: false,
  isError: false,
  errorMessage: '',
};

export const viewEditOfficeAsyn = createAsyncThunk(
  'department/viewEditOffice',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const options = {
        params: udata,
        headers: { "Authorization": `Bearer ${tokenStr}` }
      };

      const response = await axios.get('/api/detailedDepartment/deptType/', options, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      //   let response = await axios({
      //     url: '/api/detailedDepartment/deptType/',
      //     method: 'get',
      //     data:udata,
      //     //timeout: 8000,
      //     headers: {
      //         //'Content-Type': 'application/json',
      //         "Authorization" : `Bearer ${tokenStr}`
      //     }
      // })

      let data = response.data;

      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const viewEditOfficeSlice = createSlice({
  name: 'vieweditoffice',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, { payload }) => {
      state.office = [];
      state.isError = false;
      state.isSuccess = false;
      state.errorMessage = '';
    },
    setResponseState: (state, { payload }) => {
      state.isResponseState = true;
    },
    unSetResponseState: (state, { payload }) => {
      state.isResponseState = false;
    },
    setSeenStampNames: (state, { payload }) => {
      state.seenStampData = payload.data.templates;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [viewEditOfficeAsyn.fulfilled]: (state, { payload }) => {
      state.office = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = payload.message;
      return state;
    },
    [viewEditOfficeAsyn.pending]: (state) => {
      state.isFetching = true;
    },
    [viewEditOfficeAsyn.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateSlice, setResponseState, unSetResponseState, setSeenStampNames } = viewEditOfficeSlice.actions;

export function responseState() {

  return async (dispatch) => {
    dispatch(setResponseState());
  }
}

export function clearResponseState() {

  return async (dispatch) => {
    dispatch(unSetResponseState());
  }
}

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export const viewEditOfficeSelector = (state) => state.vieweditoffice;

export const updateOfficeAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const editIoAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/referenceNumber', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateIOOnlyAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};


export const getSeenStampForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.get('/api/template?limit=1000000&page=1', { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    dispatch(setSeenStampNames(data));
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateSeenStampForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/department/template', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};


export default viewEditOfficeSlice.reducer;
